import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";

export interface PackageMinMaxData {
    MinConstraint: number;
    MaxConstraint: number;
    HasMinCountConstraint: boolean;
    HasMaxCountConstraint: boolean;
}

export class CheckMinMaxConstraintResult {
    errorMessage: string;
    minMaxOk: boolean;
}

@ModuleName("PackageMinMaxConstraint")
export class PackageMinMaxConstraint implements AxInit {

    private i18NHelper = new I18nHelper();
    public packageMinMaxData: PackageMinMaxData;

    AxInit(initData: PackageMinMaxData): void {
        this.packageMinMaxData = initData;
    }

    public CheckMinMaxConstraint(count: number): CheckMinMaxConstraintResult {

        let minMaxOk: boolean = false;
        let minOk: boolean = false;
        let maxOk: boolean = false;

        if (!this.packageMinMaxData.HasMinCountConstraint && !this.packageMinMaxData.HasMaxCountConstraint) {
            let result = new CheckMinMaxConstraintResult();
            result.minMaxOk = true;
            return result;
        }

        if (this.packageMinMaxData.HasMinCountConstraint) {
            if (count >= this.packageMinMaxData.MinConstraint) {
                minOk = true;
            }
        } else {
            minOk = true; 
        }

        if (this.packageMinMaxData.HasMinCountConstraint) {
            if (count <= this.packageMinMaxData.MaxConstraint) {
                maxOk = true;
            } 
        } else {
            maxOk = true;
        }

        minMaxOk = minOk && maxOk;

        let result = new CheckMinMaxConstraintResult();
        result.minMaxOk = minMaxOk;
        result.errorMessage = this.getErrorMessage(minMaxOk, minOk, maxOk);

        return result;
    }

    // getErrorMessage
    getErrorMessage(minMaxOk: boolean, minOk: boolean, maxOk: boolean): string {
        let that = this;

        if (minMaxOk) {
            return "";
        }

        if (!minOk) {
            return `${that.i18NHelper.GetTranslation(Translations.MinQuantity)}: ${that.packageMinMaxData.MinConstraint} ${that.i18NHelper.GetTranslation(Translations.Tickets) }`;
        }

        if (!maxOk) {
            return `${that.i18NHelper.GetTranslation(Translations.MaxQuantity)}: ${that.packageMinMaxData.MaxConstraint} ${that.i18NHelper.GetTranslation(Translations.Tickets) }`;
        }
    }
}